import {
  ContractType,
  GetContractResponse,
  GetContractsResponse,
} from '@consolidocs-ui/types';
import { enhanceEndpoints } from '../core';

const ContractApiWithTag = enhanceEndpoints({
  addTagTypes: ['contracts'],
});

// Contract API Services
export const ContractApi = ContractApiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getContracts: builder.query<GetContractsResponse, void>({
      query: () => ({
        url: 'contract-types',
      }),
      providesTags: ['contracts'],
    }),
    getContract: builder.query<GetContractResponse, string>({
      query: (id) => ({
        url: `contract-types/${id}`,
      }),
    }),
    createContract: builder.mutation<ContractType, Partial<ContractType>>({
      query: (contract: ContractType) => {
        return {
          url: `contract-types`,
          method: 'POST',
          data: contract,
        };
      },
      invalidatesTags: ['contracts'],
    }),

    updateContract: builder.mutation<ContractType, Partial<ContractType>>({
      query: (contract: ContractType) => {
        return {
          url: `contract-types/${contract.id}`,
          method: 'PUT',
          data: contract,
        };
      },
      invalidatesTags: ['contracts'],
    }),

    deleteContract: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `contract-types/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['contracts'],
    }),
  }),
});

export const {
  useGetContractsQuery,
  useGetContractQuery,
  useCreateContractMutation,
  useUpdateContractMutation,
  useDeleteContractMutation,
} = ContractApi;
